import { Button, Card, Divider, Tag } from "antd";
import styles from './cardList.module.scss';
import CustomIcon from "../icons/CustomIcon";
import { Collapse } from 'antd';
import { useState } from "react";
interface CardListProps {
    items: any[],
    blueprint: any,
    handleRowLevelAction: Function,
    handleMoreActions?: Function
}
const { Panel } = Collapse;
const CardList: React.FC<CardListProps> = ({ items, blueprint, handleRowLevelAction, handleMoreActions }) => {

    const config = blueprint.cardConfig;

    const colorConfig = config.colorConfig ?? {};

    const enableShowMore:boolean = (() => {

        const totalFieldsDisplayed = blueprint.dataGrid.length - blueprint.dataGrid.filter((item:any) => item.display === false).length;
        const fieldsDisplayedOnCard = blueprint.dataGrid.filter((item:any) => item.cardDisplay === true && item.display !== false).length;
        const constantFieldsCount = 2;

        return (totalFieldsDisplayed - fieldsDisplayedOnCard - constantFieldsCount) > 0;

    })();

    const [activeKey, setActiveKey] = useState<number[]>([]); // Keeps track of the active panels

    const togglePanel = (key: number) => {
        if (activeKey.includes(key)) {
            setActiveKey([]); // Collapse if it's expanded
        } else {
            setActiveKey([key]); // Expand if it's collapsed
        }
    };

    return <div>
        {items.map((record, index) => {

            return <Card bodyStyle={{ padding: "0.5rem" }} headStyle={{ padding: "0 0.6rem" }} key={index} className={styles.dataCard + ' mb-3 text-base py-0 platform-card-list shadow'}>

                <div className="responsive-flex-between pb-2">
                    <div>
                        <p className="text-base font-medium mt-1"> <b> {record[config.heading]} </b> - {record[config.subheading]} </p>
                    </div>
                    <div>
                        {config.badges && config.badges.map((badge: any) => {
                            return record[badge.field] ? <Tag color={colorConfig[badge.field + "=" + record[badge.field]] ?? badge.color} className="p-1 font-medium text-sm">{record[badge.field]}</Tag> : <></>
                        })}
                    </div>
                </div>
                <Divider></Divider>

                <div>
                    <div className={styles.container}>

                        {blueprint.dataGrid.map((columnGrid: any) => {

                            if (columnGrid.hasOwnProperty("display") && columnGrid.display === false) {
                                return null;
                            }

                            if (columnGrid.hasOwnProperty("cardDisplay") && columnGrid.cardDisplay) {
                                return <p className="my-1"> <span className="text-primary font-medium"> {columnGrid.displayName} : </span>
                                    {record[columnGrid.field] ? <span className="font-semibold"> {record[columnGrid.field]} </span> : <span className="text-sm opacity-5"> Not Available </span>}  </p>
                            } else {
                                return <></>
                            }

                        })}

                    </div>
                </div>

                <div className={"mt-3 " + (activeKey[0] === index ? "" : "responsive-flex-between")}>
                    <div className="mt-2 pointer">
                       {enableShowMore && <span className="font-medium align-middle text-secondary" onClick={() => togglePanel(index)} >{activeKey[0] === index ? "Less Details" : "More Details"} </span>} 
                        <Collapse activeKey={activeKey}  className="py-0">
                            <Panel className="px-0 py-0" showArrow={false} header={undefined} key={index}>
                                <div className={styles.container}>

                                    {blueprint.dataGrid.map((columnGrid: any) => {

                                        if (columnGrid.hasOwnProperty("display") && columnGrid.display === false) {
                                            return null;
                                        }

                                        if (columnGrid.hasOwnProperty("cardDisplay") && columnGrid.cardDisplay === true) {
                                            return null;
                                        }

                                        if (columnGrid.field === config.heading || columnGrid.field === config.subheading) {
                                            return null;
                                        }

                                        return <p> <span className="text-primary font-medium"> {columnGrid.displayName} : </span>
                                            {record[columnGrid.field] ? <span className="font-semibold"> {record[columnGrid.field]} </span> : <span className="text-sm opacity-5"> Not Available </span>}  </p>
                                    })}

                                </div>
                            </Panel>
                        </Collapse>
                    </div>

                    <div className="text-right">
                        {blueprint.rowLevelactions.map((action: any) => {
                            return <Button icon={<CustomIcon className="align-top" name={action.displayName} color="#fff"></CustomIcon>} type="primary" className="ml-2  mt-2 mt-lg-0 opacity-9" onClick={() => handleRowLevelAction(action, record)}> <span className="align-middle"> {action.iconToolTip} </span>  </Button>
                        })}

                        {blueprint.hasOwnProperty("moreActions") && <> {handleMoreActions ? handleMoreActions(record, 'Button') : <></>}</>}

                    </div>

                </div>


            </Card>
        }

        )}

    </div>
}


export default CardList;
